// module cache are used so entry inlining is disabled
